import * as Yup from 'yup';
import { MESSAGE_ONLY_CYRILLIC_SYMBOLS } from '@/utils/validation-utils';

export const prisonerMiddleNameSchema: Yup.StringSchema = Yup.string().matches(
  /^[А-яЁё\s]+$/,
  MESSAGE_ONLY_CYRILLIC_SYMBOLS,
);
